import { getAgencySettingsOptions } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';

export function useAgencyStartOfWeek(): number {
	return useSuspenseQuery(getAgencySettingsOptions()).data.agencyStartOfWeek;
}
